<template>
  <div class="content-chunk">
    <div class="content">
      <h2
        v-if="chunk.attributes.title"
        class="content__title"
        v-html="chunk.attributes.title"
      />
      <TheContent
        v-for="content in chunk.children"
        :key="content.id"
        :elem="content"
      />
    </div>
    <WidgetsArea
      v-if="indexChunk === 0 && !isLastChunk"
      area="after-first-paragraph"
    />
    <!-- для карточек особая логика:
    1. indexChunk !== 0 - смотрим за тем, чтобы виджет не появился до первого чанка с контентом 
    2. !isLastChunk - смотрим за тем, чтобы виджет не появился в самом конце статьи после всего контента
    3. indexChunk % 2 === 0 вставляем виджеты через каждые 2 карточки
    -->
    <WidgetsArea
      v-if="indexChunk !== 0 && !isLastChunk && indexChunk % 2 === 0"
      :index-sliced-content="indexChunk"
      area="post-dynamic"
    />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import type { TContent } from '~/types/common';
  import TheContent from '~/components/TheContent';
  import WidgetsArea from '~/components/WidgetsArea/WidgetsArea.vue';

  export default defineNuxtComponent({
    name: 'ContentChunk',

    components: {
      TheContent,
      WidgetsArea,
    },

    props: {
      chunk: {
        required: true,
        type: Object as PropType<TContent>,
      },

      isLastChunk: {
        required: true,
        type: Boolean as PropType<boolean>,
      },

      indexChunk: {
        required: true,
        type: Number as PropType<number>,
      },
    },

    computed: {
      cardTitle(): string {
        return this.chunk.attributes.title;
      },
    },
  });
</script>

<style lang="scss" scoped>
  @use '~/scss/article' as *;

  .content {
    background: #fff;
    border-radius: 32px;
    padding: 32px 14px;
    margin: 24px 0;

    & > :last-child {
      margin-bottom: 0 !important;
    }

    & :deep() > {
      @include article-elems;
    }

    > {
      // у первого элемента рендер компонента в каждой карточке отступ не нужен, т.к в карточке есть падинги
      :first-child {
        margin-top: 0 !important;
      }
    }

    @include tablet {
      padding: $spacing-10 $spacing-14;
    }
    @include big-tablet {
      padding: $spacing-10 $spacing-6;
    }
    @include desktop {
      padding: $spacing-10 $spacing-17;
    }
    &__title {
      @include headline-small-text;
      word-break: break-word;
      font-family: $headline-font--1;
      color: #000;
      margin-bottom: $spacing-6;
      @include tablet {
        @include headline-medium-text;
      }
    }
  }

  .widgets-area {
    padding: $spacing-0 $spacing-4;
    margin: $spacing-0 auto;
    @include tablet {
      padding: $spacing-0 $spacing-14;
    }

    @include big-tablet {
      padding: $spacing-0;
      width: 592px;
    }

    @include desktop {
      width: 732px;
    }
  }
</style>
